import * as Sentry from '@sentry/vue'

const explicitDebugFlag = 'fmPermissionDebug'

export function isPermissionDebugEnabled() {
  if (typeof window === 'undefined') return import.meta.env.DEV
  return import.meta.env.DEV || window.localStorage?.getItem(explicitDebugFlag) === 'true'
}

function actorSummary(actor) {
  return {
    kind: actor?.kind,
    type: actor?.type,
    typeString: actor?.typeString,
    profileId: actor?.profileId,
    appUserintId: actor?.appUserintId,
  }
}

export function logPermissionDecision(eventName, decision, extra = {}) {
  if (!isPermissionDebugEnabled()) return

  console.info('[permission]', eventName, {
    action: decision?.action,
    allowed: decision?.allowed,
    reason: decision?.reason,
    mode: decision?.mode,
    route: decision?.route,
    surface: decision?.surface,
    tenantId: decision?.tenantId,
    actor: actorSummary(decision?.actor),
    evidence: decision?.evidence,
    ...extra,
  })
}

export function reportPermissionMisconfiguration(reason, payload = {}) {
  console.error('[permission] misconfiguration', {
    reason,
    ...payload,
  })

  Sentry.captureException(new Error(`Permission misconfiguration: ${reason}`), {
    extra: payload,
  })
}
